// ** React Import
import { forwardRef } from "react";

// ** MUI Imports
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { width } from "@mui/system";

const TextFieldStyled = styled(TextField)(({ theme }) => ({
  alignItems: "flex-start",
  width: "100%",

  "& .MuiInputLabel-root": {
    transform: "none",
    lineHeight: 1.154,
    position: "relative",
    marginBottom: theme.spacing(1),

    fontSize: theme.typography.body2.fontSize,
    color: `${theme.palette.text.primary} !important`,
  },
  "& .MuiInputBase-root": {
    borderRadius: 8,
    width: "100%",
    backgroundColor: "transparent !important",
    border: `1px solid #C5C4C9`,
    transition: theme.transitions.create(["border-color", "box-shadow"], {
      duration: theme.transitions.duration.shorter,
    }),
    "&:not(.Mui-focused):not(.Mui-disabled):not(.Mui-error):hover": {
      borderColor: `#b1b1b1`,
    },
    "&:before, &:after": {
      display: "none",
    },
    "&.MuiInputBase-sizeSmall": {
      borderRadius: 6,
    },
    "&.Mui-error": {
      borderColor: theme.palette.error,
    },
    "&.Mui-focused": {
      boxShadow: "0px 2px 6px 0px rgba(47, 43, 61, 0.14)",
      "& .MuiInputBase-input:not(.MuiInputBase-readOnly):not([readonly])::placeholder":
        {
          transform: "translateX(4px)",
        },
      "&.MuiInputBase-colorPrimary": {
        borderColor: "#7367F0",
      },
      "&.MuiInputBase-colorSecondary": {
        borderColor: "#7367F0",
      },
      "&.MuiInputBase-colorInfo": {
        borderColor: "#7367F0",
      },
      "&.MuiInputBase-colorSuccess": {
        borderColor: "#7367F0",
      },
      "&.MuiInputBase-colorWarning": {
        borderColor: "#7367F0",
      },
      "&.MuiInputBase-colorError": {
        borderColor: "#7367F0",
      },
      "&.Mui-error": {
        borderColor: "#7367F0",
      },
    },
    "&.Mui-disabled": {
      backgroundColor: `#F5F4F6 !important`,
    },
    "& .MuiInputAdornment-root": {
      marginTop: "0 !important",
    },
  },
  "& .MuiInputBase-input": {
    color: theme.palette.text.secondary,
    "&:not(textarea)": {
      padding: "15.5px 13px",
    },
    "&:not(textarea).MuiInputBase-inputSizeSmall": {
      padding: "7.5px 13px",
    },
    "&:not(.MuiInputBase-readOnly):not([readonly])::placeholder": {
      transition: theme.transitions.create(["opacity", "transform"], {
        duration: theme.transitions.duration.shorter,
      }),
    },

    // ** For Autocomplete
    "&.MuiInputBase-inputAdornedStart:not(.MuiAutocomplete-input)": {
      paddingLeft: 0,
    },
    "&.MuiInputBase-inputAdornedEnd:not(.MuiAutocomplete-input)": {
      paddingRight: 0,
    },
  },
  "& .MuiFormHelperText-root": {
    lineHeight: 1.154,
    margin: theme.spacing(1, 0, 0),
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
    "&.Mui-error": {
      color: theme.palette.error,
    },
  },

  // ** For Select
  "& .MuiSelect-select:focus, & .MuiNativeSelect-select:focus": {
    backgroundColor: "transparent",
  },
  "& .MuiSelect-filled .MuiChip-root": {
    height: 22,
  },

  // ** For Autocomplete
  "& .MuiAutocomplete-input": {
    paddingLeft: "6px !important",
    paddingTop: "7.5px !important",
    paddingBottom: "7.5px !important",
    "&.MuiInputBase-inputSizeSmall": {
      paddingLeft: "6px !important",
      paddingTop: "2.5px !important",
      paddingBottom: "2.5px !important",
    },
  },
  "& .MuiAutocomplete-inputRoot": {
    paddingTop: "8px !important",
    paddingLeft: "8px !important",
    paddingBottom: "8px !important",
    "&:not(.MuiInputBase-sizeSmall).MuiInputBase-adornedStart": {
      paddingLeft: "13px !important",
    },
    "&.MuiInputBase-sizeSmall": {
      paddingTop: "5px !important",
      paddingLeft: "5px !important",
      paddingBottom: "5px !important",
      "& .MuiAutocomplete-tag": {
        margin: 2,
        height: 22,
      },
    },
  },

  // ** For Textarea
  "& .MuiInputBase-multiline": {
    padding: "15.25px 13px",
    "&.MuiInputBase-sizeSmall": {
      padding: "7.25px 13px",
    },
    "& textarea.MuiInputBase-inputSizeSmall:placeholder-shown": {
      overflowX: "hidden",
    },
  },

  // ** For Date Picker
  "& + .react-datepicker__close-icon": {
    top: 11,
    "&:after": {
      fontSize: "1.6rem !important",
    },
  },
}));

const CustomTextFieldLanguage = forwardRef((props, ref) => {
  // ** Props
  const { size = "small", InputLabelProps, ...rest } = props;

  return (

  <div style={{position:'relative',marginRight:20,marginLeft:10,display:'flex'}}>
    <svg  xmlns="http://www.w3.org/2000/svg"  aria-hidden="true" role="img" font-size="1.625rem" class="iconify iconify--tabler" width="1em" height="1em" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M4 5h7M9 3v2c0 4.418-2.239 8-5 8"></path><path d="M5 9c-.003 2.144 2.952 3.908 6.7 4m.3 7l4-9l4 9m-.9-2h-6.2"></path></g></svg>
    <TextFieldStyled
    
    style={{position:'absolute',top:10,width:50,left:-10,opacity:0}}
      size={size}
      inputRef={ref}
      {...rest}
      variant="filled"
      InputLabelProps={{ ...InputLabelProps, shrink: true }}
    />
  </div>
  );
});

export default CustomTextFieldLanguage;
